import { CircularProgress } from '@mui/material'
import React from 'react'

const MaterialUISpinner = () => {
  return (
    <div>
      <CircularProgress color="inherit" size={16} />
    </div>
  )
}

export default MaterialUISpinner
